import React from 'react';
import styled from 'styled-components/macro';
import { useIsDesktop, useIsMobile } from '../hooks/useMediaQuery';
import { responsive } from '../resources/constantes.json';
import BarrasConsolidado from '../components/Barras/BarrasConsolidado';


const ConsolidadoStats = props => {
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

  return (
    <SStatsContent isDesktop={isDesktop} isMobile={isMobile}>
      <div css={isDesktop && `
      height: 100%;
      width: 100%;
      display:flex;
      justify-content:center;
      align-items:center;
      flex-direction:column;
    `}>
        {<>
          <BarrasConsolidado key={JSON.stringify(props.tipo)} tipo={props.tipo} data={props.data} />

          {/* <LeyendaContainer isDesktop={isDesktop}>
            <LeyendaItem>
              <LeyendaBarra color={themes.actColor} />
              <LeyendaData>
                <LeyendaDataYear>{constantes.años.añoAct}</LeyendaDataYear>
                <LeyendaDataNumber bigger={true}>{addDot(props.data.vot.act)}</LeyendaDataNumber>
                <LeyendaDataPercent>{props.data.pvot.act}</LeyendaDataPercent>
              </LeyendaData>
            </LeyendaItem>
            <LeyendaItem>
              <LeyendaBarra color={themes.antColor} />
              <LeyendaData>
                <LeyendaDataYear>{constantes.años.añoAnt}</LeyendaDataYear>
                <LeyendaDataNumber>{addDot(props.data.vot.ant)}</LeyendaDataNumber>
                <LeyendaDataPercent>{props.data.pvot.ant}</LeyendaDataPercent>
              </LeyendaData>
            </LeyendaItem>
            <LeyendaItem>
              <LeyendaBarra color={themes.antAntColor} />
              <LeyendaData>
                <LeyendaDataYear>{constantes.años.añoAntAnt}</LeyendaDataYear>
                <LeyendaDataNumber>{addDot(props.data.vot.antant)}</LeyendaDataNumber>
                <LeyendaDataPercent>{props.data.pvot.antant}</LeyendaDataPercent>
              </LeyendaData>
            </LeyendaItem>
          </LeyendaContainer> */}
        </>}
      </div>
    </SStatsContent>
  );
};

export default ConsolidadoStats;

const SStatsContent = styled.article`
  height: 100%;
  & h3 {
    font-weight: bold;
    font-size: 1.6rem;
    text-transform: uppercase;
  }
  & > div {
    display: flex;
    ${({ isDesktop }) => !isDesktop && 'flex-direction: column;'};
  }
  & div svg {
    ${({ isDesktop }) => !isDesktop && 'width: 75%; margin: 0 auto'};
    ${({ isMobile }) => isMobile && 'height: auto'};
  }
`;

const LeyendaContainer = styled.div`
  margin-left: 2em;
  margin-top: 2em;
  color:#164192;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(1, 1fr);


  & h3 {
    font-size: 1.2rem;
    font-weight: 900;
    text-transform: uppercase;
  }
  
  @media (max-width:${responsive.tablet}px){
      margin-top: 0;
      grid-template-columns: repeat(3, 1fr);
  }


`;

const LeyendaItem = styled.div`
  display: flex;
  margin: 1.5em 0;

  @media (max-width:${responsive.tablet}px){
      flex-direction: column;
  }
`

const LeyendaData = styled.div`
  display: flex;
  flex-direction: column;
  gap:1rem;
  @media (max-width:${responsive.mobile}px){
    gap:0.6rem;
  }
`

const LeyendaDataYear = styled.div`
    font-size: 2rem;
`

const LeyendaDataNumber = styled.div`
    font-size: ${({ bigger }) => bigger ? '5rem' : '2.5rem'};
    font-weight: bold;

    @media (max-width:${responsive.tablet}px){
      font-size: ${({ bigger }) => bigger ? '3rem' : '1.8rem'};
    }

    @media (max-width:${responsive.mobile}px){
      font-size: ${({ bigger }) => bigger ? '1.6rem' : '1.4rem'};
    }
    `

const LeyendaDataPercent = styled.div`
    font-size: 2rem;
    font-weight: bold;
  @media (max-width:${responsive.mobile}px){
    font-size: 1.4rem;
  }
`

const LeyendaBarra = styled.div`
  height: 100%;
  width: 0;
  border-left: 5px solid ${props => props.color};
  border-right: 5px solid ${props => props.color};
  border-radius: 5px;
  margin-top: 0.6rem;
  margin-right: 1rem;

  @media (max-width:${responsive.tablet}px){
    width: 80%;
    height: 14px;
    border-radius: 100px;
    background: ${props => props.color};
  }
`;

